var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -2048 2055 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(1, -1)",
    d: "M1280 1152q-80 0 -149.5 -30t-122 -82.5t-82.5 -122.5t-30 -149q0 -92 -41 -173t-115 -136q65 -33 117.5 -81.5t89.5 -108t57 -128t20 -141.5h-128q0 79 -30 149t-82.5 122.5t-122.5 82.5t-149 30q-80 0 -149.5 -30t-122 -82.5t-82.5 -122.5t-30 -149h-128q0 73 20 141.5 t57 128t89.5 108t117.5 81.5q-74 55 -115 136t-41 173q0 79 30 149t82.5 122.5t122 82.5t149.5 30q92 0 173 -41t136 -115q38 75 97 134t134 97q-74 55 -115 136t-41 173q0 79 30 149t82.5 122.5t122 82.5t149.5 30q79 0 149 -30t122.5 -82.5t82.5 -122.5t30 -149 q0 -92 -41 -173t-115 -136q65 -33 117.5 -81.5t89.5 -108t57 -128t20 -141.5h-128q0 79 -30 149t-82.5 122.5t-122.5 82.5t-149 30zM1024 1536q0 -53 20 -99.5t55 -81.5t81.5 -55t99.5 -20t99.5 20t81.5 55t55 81.5t20 99.5t-20 99.5t-55 81.5t-81.5 55t-99.5 20t-99.5 -20 t-81.5 -55t-55 -81.5t-20 -99.5zM512 512q53 0 99.5 20t81.5 55t55 81.5t20 99.5t-20 99.5t-55 81.5t-81.5 55t-99.5 20t-99.5 -20t-81.5 -55t-55 -81.5t-20 -99.5t20 -99.5t55 -81.5t81.5 -55t99.5 -20zM2048 256h-256v-256h-128v256h-256v128h256v256h128v-256h256v-128z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPeople);
export default __webpack_public_path__ + "static/media/add-people.e3bf5db3.svg";
export { ForwardRef as ReactComponent };